import TagManager from "@sooro-io/react-gtm-module";

export const pushGTMEvent = (
  eventName: string,
  payload: Record<string, unknown>,
) => {
  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...payload,
    },
  });
};
